import { getConnection } from "./adbConnection";
import { shellCmd } from "./adbShell";

/**
 * Get the versionName of an installed package via `dumpsys package`.
 * Returns null if the package is not installed.
 */
export async function getPackageVersionName(packageName: string): Promise<string | null> {
  const adb = getConnection();
  if (!adb) return null;

  const output = await shellCmd(adb, ["dumpsys", "package", packageName]);
  const line = output.split("\n").find((l) => l.includes("versionName="));
  if (!line) return null;
  return line.split("=")[1]?.trim() || null;
}

/** Compare two semver-like version strings (e.g. "1.38.0" vs "1.37.1").
 *  Returns: negative if a < b, 0 if equal, positive if a > b. */
export function compareVersions(a: string, b: string): number {
  const pa = a.split(".").map(Number);
  const pb = b.split(".").map(Number);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const na = pa[i] ?? 0;
    const nb = pb[i] ?? 0;
    if (na !== nb) return na - nb;
  }
  return 0;
}
